export default "__VITE_ASSET__1e23ecd2__"